var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CreatePerson'),_c('List',{staticClass:"my-3",attrs:{"items":_vm.salesPersons}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }